module.exports = __webpack_public_path__ + "img/icono_G7.87b1c2e7.svg";